import { TimerAction, TimerActionType } from '../actions/timer';
import { TimerNamespace } from '../state/timer';

export const timerReducer = (
    state: TimerNamespace = {
        expirationTimestamp: null,
        isTimerExpired: false,
    },
    action: TimerAction,
) => {
    switch (action.type) {
        case TimerActionType.startBackgroundTimer: {
            const expirationTimestamp = action.payload.expirationTimestamp;
            const isTimerExpired = expirationTimestamp
                ? Date.now() >= expirationTimestamp
                : false;

            return {
                ...state,
                expirationTimestamp,
                isTimerExpired,
            };
        }

        case TimerActionType.updateBackgroundTimer:
            return {
                ...state,
                isTimerExpired: action.payload.isTimerExpired,
            };

        default:
            return state;
    }
};
